import { isNumber } from "../../../omnia"
import { StockVm } from "../../../stocks/stockVm"
import { FertiliserAppUnit, INutritionPlanProductApp, NutrientType } from "../../../types"

export function updateUnits(productApp: INutritionPlanProductApp, stock: StockVm, targetNutrient: NutrientType) {

    if (!productApp) return
    if (!stock) return

    const manure = stock.isManure()

    const tonnes = manure

    const currentUnit = productApp.ProductUnit

    let unit = stock.isSolid()
        ? (tonnes ? FertiliserAppUnit.T : FertiliserAppUnit.Kg)
        : (tonnes ? FertiliserAppUnit.M3 : FertiliserAppUnit.L)

    productApp.ProductUnit = unit

    if (currentUnit != productApp.ProductUnit) {

        let factor: number
        let rounding: number

        switch (currentUnit) {

            case FertiliserAppUnit.Kg:
                if (unit == FertiliserAppUnit.T) {
                    factor = .001
                    rounding = 10
                }
                break

            case FertiliserAppUnit.L:
                if (unit == FertiliserAppUnit.M3) {
                    factor = .001
                    rounding = 10
                }
                break

            case FertiliserAppUnit.T:
                if (unit == FertiliserAppUnit.Kg) {
                    factor = 1000
                    rounding = 1
                }
                break

            case FertiliserAppUnit.M3:
                if (unit == FertiliserAppUnit.L) {
                    factor = 1000
                    rounding = 1
                }
                break

        }

        if (isNumber(factor)) {

            if (isNumber(productApp.ProductRate)) {
                productApp.ProductRate = Math.round(productApp.ProductRate * factor * rounding) / rounding
            }

            if (isNumber(productApp.NutrientRate)) {
                productApp.NutrientRate = Math.round(productApp.NutrientRate * factor * rounding) / rounding
            }

        }

    }

}

